/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewEnumerationStats
 */
export interface CRSFSecReviewEnumerationStats {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewEnumerationStats
     */
    cached?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewEnumerationStats
     */
    duration_ms?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CRSFSecReviewEnumerationStats
     */
    statuses: { [key: string]: number; };
}

/**
 * Check if a given object implements the CRSFSecReviewEnumerationStats interface.
 */
export function instanceOfCRSFSecReviewEnumerationStats(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "statuses" in value;

    return isInstance;
}

export function CRSFSecReviewEnumerationStatsFromJSON(json: any): CRSFSecReviewEnumerationStats {
    return CRSFSecReviewEnumerationStatsFromJSONTyped(json, false);
}

export function CRSFSecReviewEnumerationStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewEnumerationStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cached': !exists(json, 'cached') ? undefined : json['cached'],
        'duration_ms': !exists(json, 'duration_ms') ? undefined : json['duration_ms'],
        'statuses': json['statuses'],
    };
}

export function CRSFSecReviewEnumerationStatsToJSON(value?: CRSFSecReviewEnumerationStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cached': value.cached,
        'duration_ms': value.duration_ms,
        'statuses': value.statuses,
    };
}

